import AutoplacementGridSection from './autoplacement-grid-section';

export default AutoplacementGridSection;
